import bugsnag from '@bugsnag/js';
import bugsnagVue from '@bugsnag/plugin-vue';

export default async ({ Vue }) => {
  const bugsnagClient = bugsnag({
    apiKey: 'c94dfbcb8f64eea4330a757857ea8160',
    appVersion: `${process.env.VERSION}-${process.env.NODE_ENV}-${process.env.PLATFORM}`,
    releaseStage: process.env.NODE_ENV,
    notifyReleaseStages: ['production'],
  });

  bugsnagClient.use(bugsnagVue, Vue);

  Vue.prototype.$bugsnag = bugsnagClient;
};
